enum GeneratedOsRoutesAPI {
  GENERATED_OS_TOTAL = '/customer-portal-service/KpiGenerated/Total',
}

enum GeneratedOsRoutesApplication {
  GENERATED_OS = '/application/os-generated',
}

export {
  GeneratedOsRoutesAPI,
  GeneratedOsRoutesApplication,
};
